/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FAlertLine%2FAlertLineCounter%2FAlertLineCounter.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    '{currentSlideIndex} из {slideCount}': {
        ru: '{currentSlideIndex} из\u00A0{slideCount}',
        en: '{currentSlideIndex} out of\u00A0{slideCount}',
        tr: '{currentSlideIndex} /\u00A0{slideCount}',
        'zh-Hans': '{currentSlideIndex}/{slideCount}',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
